<template>
	<div v-if="showNavbar" :style="{'height':navbarHeight}">
		<div class="navbarbox" :class="{navbarboxtransparent:navBarType === 'transparent'}" :style="{'backgroundColor':backgroundColor,'paddingTop':phoneNavbarPadding+'px','height': phoneNavbarHeight+'px'}">
			<div class="back-icon"  @click="back">
				<span class="iconfont iconxingzhuang"  :style="{'color':color}" ></span>
			</div>
			<div class="navbarfixed" :style="{'color':color}" v-if="showTitle">
				{{navBarTitle}}
			</div>
		</div>
	</div>
</template>
<script>
	import { bridge } from '@/utils/util';
	import { getUrlParams } from '../utils';
	export default {
		name: 'navBar',
		props: {
			firstHead: {
				type: Boolean,
				default: false
			},
			isTitleShow: {
				type: Boolean,
				default: true
			},
			navBarTitle:{
				type: String,
				default: '政策补贴宝'
			},
			navBarType:{
				type: String,
				default: 'white' //white默认白色背景，transparent默认透明背景
			},
			fontColor:{
				type: String,
				default: '' //white默认白色背景，transparent默认透明背景
			},
			showEnterCompanyName:{
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				showTitle: true, // 标题显示
				backgroundColor: '#ffffff',
				color:'#000000',
				showNavbar: false,
				scrollDiv: false,
				navbarHeight: '0px',
				phoneNavbarHeight: 40,
				navBarHeight:0,
				phoneNavbarPadding: 32
			}
		},
		activated(){
			// 缓存导致组件不更新
			this.init()
		},
		mounted(){
			this.init()
		},
		methods:{
			init() {
        let clearNav = Number(localStorage.getItem('clearNav')) || Number(getUrlParams('clearNav'))
        this.showNavbar = clearNav === 1 ? true : false
        this.showTitle = this.isTitleShow
        let u_agent = navigator.userAgent
        let navbarh = u_agent.indexOf("HUAWEIANA-AN00") > -1 ? 84 : 76
        this.navBarHeight = getUrlParams('navBarHeight') || navbarh
        this.phoneNavbarPadding = this.navBarHeight ? this.navBarHeight-44:32
				this.navbarHeight = this.navBarType === 'transparent' ? '0px' : this.phoneNavbarHeight + this.phoneNavbarPadding+ 'px'
				this.color = this.fontColor
				this.backgroundColor = this.navBarType=== 'transparent' ? 'transparent' : '#ffffff'
				if (this.navBarType === 'transparent') {
					window.addEventListener('scroll', this.handleScroll)
				}
			},
			back(){
				if(this.firstHead && this.showEnterCompanyName){
					this.$emit('showTipsLayer')
				}else if(this.firstHead){
					let baseUrl = 'jsb://action=goBack'
					bridge(baseUrl)
				}else {
					this.$router.go(-1)
				}
			},
			handleScroll(){
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				if(scrollTop >= 30){
					this.backgroundColor = 'white'
					this.color = "#000000"
					this.showTitle = true
				} else {
					if(scrollTop < 3){
						this.backgroundColor = this.navBarType=== 'transparent' ? 'transparent' : '#ffffff'
						this.color = this.fontColor ? this.fontColor : '#ffffff'
						this.showTitle = this.isTitleShow ? true : false
					}
					else if(scrollTop>=3 && scrollTop < 30){
						this.backgroundColor = `rgba(255, 255, 255,${scrollTop /
						(scrollTop + 40)})`
						this.color = `rgba(0, 0, 0,${scrollTop / (scrollTop + 40)})`
						this.showTitle = true
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.navbarbox {
		position: fixed;
		box-sizing: content-box;
		left: 0;
		top: 0;
		width: 100%;
		z-index: 999;
		.navbarfixed {
			color: #000;
			text-align: center;
			height: 40px;
			line-height: 40px;
		}
		.back-icon{
			display: inline-block;
			position: absolute;
			height: 40px;
			display: flex;
			align-items: center;
			margin-left: 16px;
		}
		.iconxingzhuang{
			font-size: 20px;
			color: #000;
		}
	}
	.navbarboxtransparent{
		background: rgba(rgb(255, 255, 255), 0);
		.navbarfixed{
			color: #ffffff;
		}
		.iconxingzhuang{
			color: #ffffff;
		}
	}
</style>
